<script setup lang="ts">
import type { LegacyPortraitGalleryItem } from './legacyPortraitGalleryTypes';
// biome-ignore lint/correctness/noUnusedImports: used via <PortraitCardOverlay> in <template>
import PortraitCardOverlay from './PortraitCardOverlay.vue';

interface Props {
  portrait: LegacyPortraitGalleryItem;
  selected: boolean;
  selectedCount: number | undefined;
}

interface Emits {
  countDecrement: [event: MouseEvent, portrait: LegacyPortraitGalleryItem];
  countIncrement: [event: MouseEvent, portrait: LegacyPortraitGalleryItem];
  tryAgain: [portrait: LegacyPortraitGalleryItem];
}

// biome-ignore lint/correctness/noUnusedVariables: used in <template>
const props = defineProps<Props>();

// biome-ignore lint/correctness/noUnusedVariables: used in <template>
const emit = defineEmits<Emits>();
</script>

<template>
  <PortraitCardOverlay
    class-prefix="LegacyPortraitGallery"
    :portrait="props.portrait"
    :selected="props.selected"
    :selected-count="props.selectedCount"
    @try-again="emit('tryAgain', props.portrait)"
    @count-decrement="
      (event) => emit('countDecrement', event, props.portrait)
    "
    @count-increment="
      (event) => emit('countIncrement', event, props.portrait)
    "
  />
</template>
